// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1o89p","savePackageButton":"ClientWallet_savePackageButton__1nHG7"};